import React, { useEffect } from 'react';
import { Snackbar } from '@mui/joy';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {useEventForm} from "../context/EventFormContext";
import EventStepper from "./EventStepper";
import EventInfoStep from "./EventSteps/EventInfoStep";
import EventLocationStep from "./EventSteps/EventLocationStep";
import CategoriesStep from "./EventSteps/CategoriesStep";
import ArtistsStep from "./EventSteps/ArtistsStep";

interface EventFormProps {
    mode: 'create' | 'edit';
    eventId?: string;
}

const createEventValidate = yup.object({
    name: yup.string().required(),
    start_date: yup.date().required(),
    end_date: yup.date().required(),
    location_name: yup.string().required(),
    address: yup.string().required(),
    city: yup.string().required(),
    price: yup.number().required(),
    ticketing_link: yup.string().required(),
});

const EventForm = ({ mode, eventId }: EventFormProps): React.ReactElement => {
    const {
        step,
        loadLocalisations,
        loadSubCategories,
        submitEvent,
        updateEvent,
        loadEvent,
    } = useEventForm();

    const { handleSubmit } = useForm({
        resolver: yupResolver(createEventValidate),
    });

    const [snackbar, setSnackbar] = React.useState({
        open: false,
        color: 'success' as 'danger' | 'primary' | 'neutral' | 'success' | 'warning' | undefined,
        message: '',
    });

    // Chargement des données communes, et de l'évènement en mode édition
    useEffect(() => {
        loadLocalisations();
        loadSubCategories();
        if (mode === 'edit' && eventId) {
            loadEvent(eventId);
        }
    }, [loadLocalisations, loadSubCategories, mode, eventId, loadEvent]);

    // Soumission finale du formulaire
    const onSubmit = async (data: any) => {
        if (mode === 'create') {
            await submitEvent();
        } else if (mode === 'edit' && eventId) {
            console.log(mode);
            console.log(eventId);
            await updateEvent(eventId);
        }
    };

    return (
            <section id="EventForm">
                <EventStepper/>

                <form onSubmit={handleSubmit(onSubmit)}>
                    {step === 1 && (
                        <EventInfoStep/>
                    )}

                    {step === 2 && (
                        <EventLocationStep/>
                    )}

                    {step === 3 && (
                        <CategoriesStep/>
                    )}

                    {step === 4 && (
                        <ArtistsStep onSubmit={onSubmit}/>
                    )}
                </form>

                <Snackbar
                    open={snackbar.open}
                    variant="soft"
                    color={snackbar.color}
                    autoHideDuration={3000}
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                >
                    {snackbar.message}
                </Snackbar>
            </section>
    );
};

export default EventForm;